export const useStoreArticleBlock = () => {
  document
    .querySelectorAll('img[src^="https://st.hzcdn.com/simgs/"]')
    .forEach(function (element) {
      if (element !== null) {
        const url = element.getAttribute('src').replace('_3-', '_9-');
        element.setAttribute('src', url);
        element.setAttribute('loading', 'lazy');
        element.width = '700';
      }
    });
};
